module.exports = __webpack_public_path__ + "img/DSCN0283.f094ddc1.jpg";